import { get, put, post } from 'lib/API';

export const getUserBusinessUnits = async (
    { token }: any
) => {
    return await get(`v1/businessUnits/user`, token);
}

export const getAllBusinessUnits = async (
    queryParams: string,
    token: any
) => {
    return await get(`v1/businessUnits?${queryParams}`, token);
}

export const getBusinessUnit = async (
    [id,vendorId]: any[],
    {token}: any
) => {
    return await get(`v1/businessUnits/${id}/${vendorId}`, token);
}

export const createBusinessUnit = async (
    [data]: any,
    {token}: any
) => {
    return await post(`v1/businessUnits`, token, data);
}

export const updateBusinessUnit = async (
    [data]: any,
  { token }: any
) => {
    return await put(`v1/businessUnits/${data.id}`, token, data);
}


export const deletBusinessUnits = async (
    [unitIds]: any,
    { token }: any
) => {
    return await put(`v1/businessUnits/bulk/delete`, token, { unitIds });
}

export const inviteUserToBusinessUnit = async (
    [data]: any,
    { token }: any
) => {
    return await post(`v1/businessUnits/`, token, data);
}